import * as React from 'react'
import Svg, { SvgProps, Defs, LinearGradient, Stop, G, Path, Text, TSpan, Circle, Rect } from 'react-native-svg'
import { formatNumber } from '../index.native'
import { Platform, TouchableOpacity } from 'react-native'
/* SVGR has dropped some elements not supported by react-native-svg: title */
const AR_2 = ({
  props,
  report,
  year,
  onClose,
}: {
  props?: SvgProps
  report: Record<string, any>
  year: string
  onClose: () => Promise<void>
}) => {
  const sales = formatNumber(report?.data?.sales?.total ?? 0)
  return (
    <>
      <Svg width={393} height={852} {...props}>
        <Defs>
          <LinearGradient id="a" x1="0%" x2="100%" y1="100%" y2="0%">
            <Stop offset="0%" stopColor="#2B85D1" />
            <Stop offset="100%" stopColor="#73167B" />
          </LinearGradient>
        </Defs>
        <G fill="none" fillRule="evenodd">
          <Path fill="#FFF" d="M0 0h393v852H0z" />
          <Path fill="url(#a)" d="M81.013 0h902v902h-902z" transform="translate(-260.013)" />
          <Path
            fill="#0E0E1C"
            d="M107.866 397.13H671.1c53.265 0 96.444 36.271 96.444 81.014 0 44.742-43.18 81.012-96.444 81.012H107.866c-53.264 0-96.444-36.27-96.444-81.012 0-44.743 43.18-81.013 96.444-81.013Z"
            opacity={0.202}
          />
          <Path
            fill="#FFF"
            d="M-62.134 317.862H723v440.904H-62.134c-121.599 0-197.879-102.269-197.879-228.423 0-126.155 81.013-212.48 197.88-212.48Z"
            opacity={0.02}
          />
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={30}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={123.395} y={208}>
              {'Herzlichen '}
            </TSpan>
            <TSpan x={106.28} y={258}>
              {'Gl\xFCckwunsch'}
            </TSpan>
          </Text>
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_500Medium'}
            fontSize={24}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={25} y={378}>
              {`Dein Shop hat im Jahr ${year}`}
            </TSpan>
          </Text>
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_500Medium'}
            fontSize={24}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={83} y={596}>
              {'Euro Umsatz gemacht.'}
            </TSpan>
          </Text>
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={80}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={70} y={509}>
              {sales}
            </TSpan>
          </Text>
          <G transform="translate(351 50)" onPress={onClose}>
            <Circle cx={14.5} cy={14.5} r={14.5} fill="#1E2239" />
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.711 21.228a1.25 1.25 0 1 1-1.92 1.6l-5.29-6.38-5.29 6.347a1.247 1.247 0 0 1-1.76.16 1.25 1.25 0 0 1-.16-1.76l5.582-6.7L7.29 7.83a1.25 1.25 0 1 1 1.92-1.6l5.29 6.346 5.29-6.348a1.249 1.249 0 1 1 1.92 1.6l-5.583 6.7 5.584 6.7Z"
            />
          </G>
          <G fill="#D8D8D8" transform="translate(10 61.596)">
            <Rect width={36.056} height={4.807} rx={2.404} />
            <Rect width={36.056} height={4.807} x={42.065} rx={2.404} />
            <Rect width={36.056} height={4.807} x={84.13} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={126.195} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={167.659} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={209.711} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={250.827} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={291.944} opacity={0.376} rx={2.404} />
          </G>
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M201.5 670.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 202.11 659a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM40.5 259.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 41.11 248a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25H42.234l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM334.571 686.571a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.858a2.572 2.572 0 0 1-2.572 2.571h-1.714a2.572 2.572 0 0 1-2.572-2.571V686.57ZM326 696.857a2.572 2.572 0 0 1 2.571-2.571h1.715a2.572 2.572 0 0 1 2.571 2.571v8.572a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571v-8.572Zm21.429-9.428A2.572 2.572 0 0 1 350 690v15.429a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571V690a2.572 2.572 0 0 1 2.571-2.571h1.715ZM66 740.174c0 .648-.552 1.174-1.232 1.174H44.232c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H54.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393H48.586c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837ZM359 153.174c0 .648-.552 1.174-1.232 1.174h-20.536c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H347.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393h-11.828c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837Z"
            opacity={0.292}
          />
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={40}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={10} y={129}>
              {'Umsatz'}
            </TSpan>
          </Text>
        </G>
      </Svg>
      {Platform.OS === 'web' && (
        <TouchableOpacity
          onPress={onClose}
          style={{ position: 'absolute', top: 50, marginLeft: 330, width: 50, height: 50 }}
        />
      )}
    </>
  )
}
export default AR_2
